import { render, staticRenderFns } from "./taskDataPic.vue?vue&type=template&id=052949e5&scoped=true&"
import script from "./taskDataPic.vue?vue&type=script&lang=js&"
export * from "./taskDataPic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "052949e5",
  null
  
)

export default component.exports